import React from "react";
import '../../styles/components/loading-animation/loading-animation2.scss';

export default function LoadingAnimation2({additionalClassName=""}: {additionalClassName?: string}) {
  return (
    <div className={`loading-animation2 ${additionalClassName}`}>
      <div className="loader-container">
        <div className={`loader-box`}>
          &nbsp;
        </div>
        <div className={`loader`}>Loading</div>
      </div>
    </div>
  );
}